import { Typography, Box, Divider, Accordion, AccordionDetails, AccordionSummary, ButtonGroup, Tooltip, Button } from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OrbotnikIcon from '@rhino/shared/components/common/Icons/Icons';
import { ButtonWithAuth, IconButtonWithAuth, SettingType } from '@rhino/shared/services/auth/auth';

interface SidebarContentProps {
    hideSideBar: () => void;
}

export const SidebarContent: React.FC<SidebarContentProps> = ({ hideSideBar }) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const [expanded, setExpanded] = useState<string | false>('admin');
    const [subExpanded, setSubExpanded] = useState<string | false>(false);

    // Extract query parameters
    const queryParams = new URLSearchParams(location.search);

    // Determine active menu item
    let currentAdminRoute = '';

    // Define menu settings with subTabs
    const settings: SettingType[] = [];


    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                <Box sx={{ display: 'flex', mr: 1, width: '24px', height: '24px', alignItems: 'center' }}>
                    <img src="/assets/images/orbotnik_54X54.svg" alt="Sputnik" style={{ width: '100%', height: '100%' }} />
                </Box>
                <Typography 
                    variant="h6" 
                    noWrap 
                    component="a" 
                    href="/" 
                    sx={{
                        mr: 2, 
                        display: { xs: 'none', md: 'flex' }, 
                        fontFamily: 'monospace',
                        fontWeight: 700, 
                        letterSpacing: '.3rem', 
                        color: 'inherit', 
                        textDecoration: 'none'
                    }}
                >
                    ORBOTNIK
                </Typography>
            </Box>
            <Divider />

            <Accordion expanded={expanded === 'admin'} onChange={() => setExpanded(expanded === 'admin' ? false : 'admin')}>
                <AccordionSummary expandIcon={<OrbotnikIcon iconName='ExpandMore' />}>
                    <Typography variant="button">ADMINISTRATION</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                        {settings.map((setting) => (
                            <Box 
                                key={setting.key} 
                                onMouseEnter={() => setSubExpanded(setting.key)} 
                                onMouseLeave={() => setSubExpanded(false)}
                            >
                                {/* Main Menu Button */}
                                <ButtonWithAuth setting={setting} />

                                {/* If submenu exists, show hover expansion */}
                                {setting.subTabs && subExpanded === setting.key && (
                                  <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                    <ButtonGroup
                                      orientation="vertical"
                                      aria-label="vertical outlined button group"
                                    > 
                                      {setting.subTabs.map(sub => (
                                          // <ButtonWithAuth key={sub.key} setting={sub} />
                                          <Tooltip title={sub.tooltip} key={sub.iconname}>
                                            <Button
                                              sx={{
                                                my: 0,
                                                display: 'block',
                                                color: "default",
                                                ...sub.sxstyles , 
                                              }}
                                              size="small"
                                              variant="contained"
                                              onClick={(event) => {
                                                if (sub.onClick) {
                                                  sub.onClick(event);
                                                }
                                                if (sub.route) {
                                                  navigate(sub.route);
                                                }
                                              }}
                                            >
                                              {sub.caption}
                                            </Button>          
                                          </Tooltip>                                          
                                      ))}
                                      </ButtonGroup>
                                  </Box>
                                                           
                                )}
                            </Box>
                        ))}
                    </Box>
                </AccordionDetails>
            </Accordion>

        </>
    );
};
